const PAGES = {
  EXTERNAL_ENDPOINTS: {
    GEOIP: `${process.env.GEO_IP_API ?? 'http://geo-ip.green.room'}/api/v1/country`,
  },

  ENDPOINTS: {
    ROOT: '/',
    ENTRY: '/spintowin/entry',
    SURVEY: '/survey',
    GEOIP: '/geoip',
    GENERATE_IMAGE: {
      ROOT: '/generate-image',
      BYDB: {
        DREAM_BAG: '/generate-image/bydb/dream-bag',
        SUBMISSION: '/generate-image/bydb/submission',
      },
    },
    PRIZE: '/spintowin/prize',
  },

  CLIENT: {
    ROOT: '/',
    BYDB: {
      PREFIX: '/buildyourdreamsetup',
      LANDING: '/landing',
      SELECTION: '/selection',
      ENTRY: '/entry',
      SURVEY: '/survey',
      SUBMISSION: '/submission',
      HOLDING: '/closed',
    },
    UCT: {
      PREFIX: '/ultimate_coaching_trip',
      LANDING: '/',
      ENTRY: '/entry',
      SURVEY: '/survey',
      SUBMISSION: '/submission',
      HOLDING: '/closed',
    },
    GREATESTHITS: {
      PREFIX: '/greatesthits',
      SURVEY: '/survey',
      SUBMISSION: '/submission',
      HOLDING: '/closed',
    },
    SPINTOWIN: {
      PREFIX: '/spintowin',
      LANDING: '/landing',
      ENTRY: '/entry',
      SPIN: '/spintowin',
      HOLDING: '/closed',
      SUBMISSION: '/submission',
    },
  },
}

export default PAGES
